import { enUS } from "../../locales/enUS.mjs";
export const EVENT_CALENDAR_DEFAULT_LOCALE_TEXT = enUS.components.MuiEventCalendar.defaultProps.localeText;
export const EVENT_TIMELINE_DEFAULT_LOCALE_TEXT = enUS.components.MuiEventTimeline.defaultProps.localeText;